import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    background-color: #000000;
    padding: 2.8em 5.5em;

    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .container {
        display: flex;
        justify-content: flex-start;
        align-items: baseline;
        flex-wrap: wrap;
        width: 100%;
        .container-element {
            width: 29%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            &:not(:last-child) {
                margin-right: 2em;
            }
            &:nth-child(n + 4) {
                margin-top: 2em;
            }
            .icon {
                padding-right: .8em;
                width: max-content;
            }

            .element-content {
                color: #FFFFFF;

                &-company-address {
                    text-transform: capitalize;
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        padding: 2em;
        flex-direction: column;

        .container {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1em 0;

            .container-element {
                width: 100%;
                &:not(:last-child) {
                margin-right: 0;
                margin-bottom: 2em;
                }
                &:nth-child(n + 4) {
                margin-top: 0;
                }
                &:last-of-type {
                    padding-top: 0;
                }
            }
        }

    }
`;